import i18n from "../i18n";
import { Card, Text, Group, Badge, Tabs } from "@mantine/core";
import moment from "moment";
import { useState, useEffect } from "react";
import "./aiRequestPayloadEmailViewer.css";
import FileList from "./fileList";

const AIRequestPayloadEmailViewer = ({ form, name, label }) => {
  const payload = form.values?.payload;
  const email = payload?.email;
  const attachments = email?.attachments?.reverse();
  const htmlAttachment = attachments?.find(
    (attachment) => attachment.mimetype === "text/html"
  );

  if (!email) {
    return null;
  }

  return (
    <>
      <Card withBorder>
        <Text size="sm">
          <div>
            <b>Subject:</b> {email.subject}
          </div>
          <div>
            <b>Date:</b> {moment(email.date).format("YYYY-MM-DD HH:mm:ss")}
          </div>
        </Text>
      </Card>
      {email && (
        <Card withBorder mt="md">
          <Tabs defaultValue="body">
            <Tabs.List mb="md">
              <Tabs.Tab value="body">{i18n.t("Body")}</Tabs.Tab>
              <Tabs.Tab value="attachments">{i18n.t("Attachments")}</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="body">
              {htmlAttachment && htmlAttachment.url && (
                <iframe
                  src={`${htmlAttachment.url}`}
                  title="description"
                  style={{ width: "100%", height: "1000px" }}
                ></iframe>
              )}
              {!htmlAttachment && email?.textAsHtml && (
                <iframe
                  srcDoc={`${email.textAsHtml}`}
                  title="description"
                  style={{ width: "100%", height: "1000px" }}
                ></iframe>
              )}
            </Tabs.Panel>
            <Tabs.Panel value="attachments">
              <FileList
                staticFiles={attachments}
                height={500}
                showScroll={true}
                tableMarginBottom={0}
                disabled={true}
              />
            </Tabs.Panel>
          </Tabs>
        </Card>
      )}
    </>
  );
};

export default AIRequestPayloadEmailViewer;
